import  { getDependencies, getAllQuestion, setQuestion } from '../indexDB/logic.js';

export const createJsonForm =  async() => {
    await setQuestion();
    const { simple, compound, listener } = await getDependencies();
    const allQuestions = await getAllQuestion();

    let Form = [...allQuestions];

    Form = Form.map( (question) => {
        const _simple =  getCreated(simple, question.name);
        const _compound =  getCompound(compound, question.name);
        const _listener =  getListener(listener, question.name);

        if(_simple) question.related = _simple;
        if(_compound) question.related = _compound;
        if(_listener) question.related = _listener;
        if(question.help.length === 0) delete question.help;
        return question;
    });
    return Form;
};

const getCreated = (simple, nameQuestion) => {
    for(var i in simple) {
        if(simple[i][nameQuestion]) {
            return simple[i][nameQuestion];
        }
    }
}

const getCompound = (compound, nameQuestion) => {
    if(compound[nameQuestion]) {
        return compound[nameQuestion]
    }
}

const getListener = (listener, nameQuestion) => {
    if(listener[nameQuestion]) {
        return listener[nameQuestion].related;
    }
}
